module.exports = __webpack_public_path__ + "static/media/4.599b7106.jpg";